import './FilterWrapper.scss'

import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { COUNTRY_COLORS } from '../../constants/country-color'
import { Empresas } from '../../constants/empresas'
import { Proyectos } from '../../constants/proyectos'
import { IProyectos } from '../../data/data.model'
import { Filters } from '../Filters/Filters'
import { ProjectHexagon } from '../FilterTable/components/ProjectHexagon'
import { FilterTable } from '../FilterTable/FilterTable'
import { SectionHeader } from '../SectionHeader/SectionHeader'
import { CustomButton } from '../CustomButton/CustomButton'
import DownloadConfirmationModal from '../DownloadConfirmationModal/DownloadConfirmationModal'

export const FilterWrapper = () => {
  const { t, i18n }: any = useTranslation()
  const [isMobile, setIsMobile] = useState(
    window.matchMedia('(max-width: 768px)').matches
  )
  const [proyectosData, setProyectosData] = useState<IProyectos[]>([])
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)')
    const handleChange = (e: any) => setIsMobile(e.matches)

    mediaQuery.addEventListener('change', handleChange)

    if (Proyectos.length > 0 && Empresas.length > 0) {
      const proyectosEmpresas = Proyectos.map((proyecto: IProyectos) => {
        const empresas: string[] = []
        proyecto.id_empresas_carbono_desarrolladora.forEach(
          (id_empresa: string) => {
            const empresa = Empresas.find(
              (empresa) => empresa.id_empresa_carbono === id_empresa
            )
            if (empresa) {
              empresas.push(empresa.nombre_empresa)
            }
          }
        )

        return {
          ...proyecto,
          empresas_desarrolladoras: empresas,
        }
      })

      setProyectosData(proyectosEmpresas)
    }
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  const handleDownloadClick = () => {
    setIsDownloadModalOpen(true)
  }

  const handleDownloadConfirm = () => {
    const currentLang = i18n.language || 'es'
    const fileNameMap: { [key: string]: string } = {
      en: 'radiografia_en_2812.xlsx',
      es: 'radiografia_es_2812.xlsx',
      pt: 'radiografia_pt_2812.xlsx',
    }

    const fileName = fileNameMap[currentLang] || fileNameMap['es']
    const fileUrl = `/downloads/${fileName}`

    // Create a temporary anchor element to trigger download
    const link = document.createElement('a')
    link.href = fileUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <div className="project-filters">
      <div className="filterDescription">
        <div>
          <SectionHeader
            title={t('filters.title')}
            description={t('filters.description')}
            maxWidth="500px"
          ></SectionHeader>

          <CustomButton
            to=""
            icon="download"
            customAction={handleDownloadClick}
            customClass="download"
          >
            {t('downloadData')}
          </CustomButton>
        </div>
        <ul className="paises">
          <li>
            <ProjectHexagon
              size={!isMobile ? 20 : 15}
              fill={COUNTRY_COLORS.brasil}
            />
            {t('countries.brasil')}
          </li>
          <li>
            <ProjectHexagon
              size={!isMobile ? 20 : 15}
              fill={COUNTRY_COLORS.colombia}
            />
            {t('countries.colombia')}
          </li>
          <li>
            <ProjectHexagon
              size={!isMobile ? 20 : 15}
              fill={COUNTRY_COLORS.peru}
            />
            {t('countries.peru')}
          </li>
        </ul>
      </div>

      <Filters data={proyectosData}></Filters>
      <FilterTable data={proyectosData}></FilterTable>

      <DownloadConfirmationModal
        open={isDownloadModalOpen}
        onClose={() => setIsDownloadModalOpen(false)}
        onConfirm={handleDownloadConfirm}
      />
    </div>
  )
}
